var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('router-link',{staticClass:"button is-info",attrs:{"to":{ name: 'subreddits'}},on:{"click":function($event){return _vm.login()}}},[_vm._v("Ver foro")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }